<template>
	<div class="publicBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>我的发票</li>
			</ul>
			<div class="flexBox btnList">
				<a-button class="btn" @click="clickReq">立即开票</a-button>
			</div>
		</div>

		<a-table class="publicTable" :columns="columns" :data-source="tableData" :rowKey="res => {return res.id}"
			:pagination="pageData" @change="changePage" >
			<span slot="status" slot-scope="text" :class="stateList[text].class">
				{{ stateList[text].name}}
			</span>
			<div slot="operation" slot-scope="text,record" class="opera">
				<div class="item flexBox" @click="clickDown(record)" v-if="record.pdfUrl">
					<img src="../../../assets/img/admin/icon_5.png" class="icon">
					<span>下载</span>
				</div>
				<div class="item flexBox" @click="clickLook(record)">
					<img src="../../../assets/img/admin/icon_6.png" class="icon">
					<span>详情</span>
				</div>
				<div class="item flexBox" @click="clickReissue(record)" v-if="record.status!=0&&record.reissueCount<3">
					<img src="../../../assets/img/admin/icon_7.png" class="icon">
					<span>换开</span>
				</div>
			</div>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'Bill',
		components: {},
		data() {
			return {
				tableLoad: false,
				tableData: [],
				columns: [{
					title: '序号',
					dataIndex: 'id',
					width: 80,
					scopedSlots: {
						customRender: 'id'
					},
					align: 'center',
					customRender: (text, record, index) => {
						return (this.pageData.current - 1) * this.pageData.pageSize + index + 1;
					}
				}, {
					title: '发票抬头',
					dataIndex: 'invoiceTitle',
					scopedSlots: {
						customRender: 'invoiceTitle'
					}
				},{
					title: '开票金额（元）',
					dataIndex: 'invoiceAmount',
					scopedSlots: {
						customRender: 'invoiceAmount'
					},
				}, {
					title: '类型',
					dataIndex: 'invoiceType',
					scopedSlots: {
						customRender: 'invoiceType'
					},
				},{
					title: '邮箱',
					dataIndex: 'contactEmail',
					scopedSlots: {
						customRender: 'contactEmail'
					},
				}, {
					title: '申请日期',
					dataIndex: 'applyTime',
					scopedSlots: {
						customRender: 'applyTime'
					},
				}, {
					title: '状态',
					dataIndex: 'status',
					scopedSlots: {
						customRender: 'status'
					},
				}, {
					title: '完成日期',
					dataIndex: 'completeTime',
					scopedSlots: {
						customRender: 'completeTime'
					},
				}, {
					title: '操作',
					dataIndex: 'operation',
					fixed: 'right',
					scopedSlots: {
						customRender: 'operation'
					},
				}],
				stateList:[{
					name:"换开中",
					class:""
				},{
					name:"已完成",
					class:"blue"
				},{
					name:"已换开",
					class:"orange"
				},{
					name:"已拒绝",
					class:"red"
				}],
				pageData: {
					current: 1,
					pageSize: 10,
					total: 0,
					showLessItems: true,
					showTotal: total => `共 ${total} 条`
				},
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			getData(){
				this.$reqToken("get", "/api/center/invoice/list",{
					pageNum: this.pageData.current,
					pageSize: this.pageData.pageSize,
				},true).then((res) => {
					this.updateTable(res);
				})
			},
			updateTable(data) {
				this.tableData = data.rows;
				this.pageData.total = data.total;
			},
			changePage(res){
				this.pageData.current = res.current;
				this.getData()
			},
			clickLook(res){
				this.$router.push({
					path:"/admin/billDes",
					query:{
						id:res.id
					}
				})
			},
			clickReq(){
				this.$router.push("/admin/billReq")
			},
			clickReissue(record){
				this.$router.push({
					path:"/admin/billReissue",
					query:{
						id:record.id
					}
				})
			},
			clickDown(res){
				window.open(res.pdfUrl,"_blank");
			}
		}
	}
</script>

<style scoped>
.opera {
	display: flex;
	align-items: center;
	gap: 10px;
}

</style>